import { render, staticRenderFns } from "./FaqMenu.vue?vue&type=template&id=9764a94a&scoped=true&"
import script from "./FaqMenu.vue?vue&type=script&lang=js&"
export * from "./FaqMenu.vue?vue&type=script&lang=js&"
import style0 from "./FaqMenu.vue?vue&type=style&index=0&id=9764a94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9764a94a",
  null
  
)

export default component.exports